import { Location } from "@angular/common";
import { HttpResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import {
    ActivatedRouteSnapshot,
    Resolve,
    RouterStateSnapshot,
} from "@angular/router";
import { ApiGateway, PageOptions, PayType } from "cw-backend";
import { CwUtils } from "cw-utils";
import { BehaviorSubject, Observable } from "rxjs";

@Injectable()
export class PayTypeListProvider implements Resolve<any> {
    payType: PayType[];
    payTypeEdit: PayType;
    onDataChanged: BehaviorSubject<any>;
    routeParams: any;
    state: any;
    pageOptions: PageOptions;
    currentPage: PageOptions;

    constructor(public gw: ApiGateway, private location: Location) {
        this.onDataChanged = new BehaviorSubject({});
    }

    resolve(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Observable<any> | Promise<any> | any {
        this.routeParams = route.params;

        // Get state for current or new page
        this.state = this.location.getState();
        this.currentPage = this.state?.currentPage;
        this.payTypeEdit = this.state?.currentPayType;

        if (this.currentPage) {
            this.pageOptions = this.currentPage;
            this.pageOptions.fieldSort = "name";
        } else {
            this.pageOptions = new PageOptions();
            this.pageOptions.fieldSort = "name";
        }
        return new Promise<void>((resolve, reject) => {
            Promise.all([this.getPage(this.pageOptions)]).then(() => {
                resolve();
            }, reject);
        });
    }

    get(id: number): Observable<PayType> {
        if (!id) {
            return null;
        }
        return this.gw.get("payType/:id", { id: id });
    }

    get currentPayType(): PayType {
        return this.payTypeEdit;
    }

    getAll(): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.get("payType/").subscribe((res: HttpResponse<any>) => {
                this.payType = res.body;
                resolve(res);
            }, reject);
        });
    }

    getPage(pageOptions: PageOptions): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw
                .post("payType/search", pageOptions)
                .subscribe((res: HttpResponse<any>) => {
                    if (
                        !CwUtils.compare(this.payType, res.body.content) &&
                        res.body.content.length > 0
                    ) {
                        this.payType = res.body.content;
                        this.onDataChanged.next(this.payType);
                    } else {
                        this.payType = res.body.content;
                    }
                    resolve(res);
                }, reject);
        });
    }

    getPagSpec(pageOptions: PageOptions, payTypeId: number): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw
                .post(`payType/payTypeSpec/search/${payTypeId}`, pageOptions)
                .subscribe((res: HttpResponse<any>) => {
                    resolve(res);
                }, reject);
        });
    }

    getPageSimpleList(pageOptions: PageOptions): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw
                .post(`payType/search/simple-list-to`, pageOptions)
                .subscribe({
                    next: (res: HttpResponse<any>) => {
                        resolve(res);
                    }, error: (err) => {
                        reject(err)
                    }
                });
        });
    }

    getPageSettings() {
        if (this.currentPage) {
            return this.pageOptions;
        } else {
            return;
        }
    }
}
